<script>
import {useTabStore} from '@store/tabStore';
import {PermissionMap} from '@mixins/const/permissionConst';

/* COMPOSANTS */
import GaView from '@components/v2/layout/GaView';
import StayRateConsultation from '@views/accounting/visitortax/tabs/StayRateConsultation.vue';
import StayRateTransfert from '@views/accounting/visitortax/tabs/StayRateTransfert.vue';
import AkButtonValidation from '@components/v2/general/AkButtonValidation.vue';
import GaTds from '@views/accounting/crg/sidebar/GaTds.vue';

/* MIXINS */
import utilsMixin from '@mixins/utilsMixin';
import permissionsMixin from '@mixins/permissionsMixin';
import stayRatesTabMixin from '@mixins/tab/stayRatesTabMixin';
import AkButtonAction from '../../../components/v2/general/AkButtonAction.vue';

/* SERVICES */

export default {
  components: {
    GaTds,
    AkButtonAction,
    GaView,
    StayRateTransfert,
    StayRateConsultation,
    AkButtonValidation,
  },
  mixins: [utilsMixin, permissionsMixin, stayRatesTabMixin],
  head() {
    return {
      title: 'accounting.visitor_tax',
    };
  },
  data() {
    return {
      tabSelected: undefined,
    };
  },
  mounted() {
    this.tabSelected = useTabStore().getTabActive('StayRatePage', undefined);
  },
  computed: {
    activeTab() {
      if (this.tabSelected) return this.tabSelected;
      return 'stayRateConsultation';
    },

    hasManagePermission() {
      return this.hasPermission(PermissionMap.TDS.MANAGE);
    },
  },
  methods: {
    displayTab(tab) {
      useTabStore().setTabActive('StayRatePage', tab.id);
      this.tabSelected = tab.id;
    },

    // DOWNLOAD

    download() {
      this.$refs.stayRateConsultation.download(this.$refs.btnDownload);
    },

    showSidebarDownloadTds() {
      this.$refs.sidebarDownloadTds.show();
    },

    // FLAG

    flagStayrates() {
      this.$refs.stayRateConsultation.flagStayrates(this.$refs.btnSubmit);
    },
  },
};
</script>
<template>
  <GaView>
    <template #action>
      <div class="flex justify-end gap-4" v-if="isStayRateConsultation">
        <AkButtonAction secondary :label="$t('payment.download')" little @click="download()" />
        <AkButtonAction secondary label="Télécharger un rapport de TDS" little @click="showSidebarDownloadTds()" />

        <AkButtonValidation
          v-if="isStayRateConsultation && this.hasManagePermission"
          ref="btnSubmit"
          :label="$t('visitor_tax.submit')"
          btn-class="btn-primary xs"
          @action="flagStayrates" />
      </div>
    </template>
    <template #content>
      <StayRateConsultation
        ref="stayRateConsultation"
        v-if="isStayRateConsultation"
        @tab="this.displayTab"
        :tabs="tabs" />
      <StayRateTransfert v-if="isStayRateTransfert" @tab="this.displayTab" :tabs="tabs" />
    </template>
    <template #extra>
      <GaTds ref="sidebarDownloadTds" />
    </template>
  </GaView>
</template>
